import { jsPDF } from "jspdf";
import { PDFConstants } from "../static/pdfConstants";

export const initializePDF = (orientation = "portrait") => {
	const doc = new jsPDF({ orientation: orientation });
	PDFConstants.pageHeight = doc.internal.pageSize.height;
	return doc;
};
